<template>
<div>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<div class="content_card" v-if="!loading">

<div class="grid">
<div class="col-12">
<div class="content_card_content evaluation_wrap">



<QuizPreviewProgress ></QuizPreviewProgress>
  
<router-view v-slot="{ Component }" :key="$route.fullPath">
<transition name="routeslide" mode="out-in">
  <component :is="Component" />
</transition>
</router-view>





</div>


</div>
</div>
</div>




</div>
</template>
<script>
export default {

  name: 'QuestionlistPreview',

  data () {
    return {
    	data:null,
    	loading:true,
      verification_data_missing:false,
    }
  },
  mounted()
  {
  	this.loading = true
  	this.getData()
  },
  computed:{

  },
  methods:{
  	async getData()
  	{
  		console.log("getdata")
  		this.loading = await true
  		this.$store.dispatch('evaluation/setMode',"admin_viewing") 
  		let audit_inputfields_data = await this.generalApiGet("audit/get_audit_inputfields_data_for_preview/"+this.$route.params.id)
  		console.log(audit_inputfields_data)
  		await this.$store.dispatch('evaluation/setNullreasons',audit_inputfields_data.nullreasons)
  		for(let condition of audit_inputfields_data.questionlist_conditions)
        {
          condition.conditions = await JSON.parse(condition.conditions)
          condition.outcome = await JSON.parse(condition.outcome)
        }
        await this.$store.dispatch('evaluation/setQuestionlistConditions',audit_inputfields_data.questionlist_conditions) 


        await this.arrangeAuditInputfields(audit_inputfields_data)

        if(audit_inputfields_data.qu_list.type=="same_question_pattern")
		{
			let inputfields = await this.$store.state.evaluation.inputfields
			for(let item of inputfields)
			{
				item.columns = await audit_inputfields_data.qu_list.columns
				item.options = await audit_inputfields_data.qu_list.options
			}
			await this.$store.dispatch('evaluation/setInputfields',inputfields)
		}
        await this.calculateEvaluationProgress("first_init")
        await this.gotoPage("QuestionlistPreviewProgress") 
        this.loading = await false
  	}
  }
}
</script>

<style lang="css" scoped>
</style>